import { render, staticRenderFns } from "./GroupTag.vue?vue&type=template&id=38415ad2&scoped=true&"
import script from "./GroupTag.vue?vue&type=script&lang=ts&"
export * from "./GroupTag.vue?vue&type=script&lang=ts&"
import style0 from "./GroupTag.vue?vue&type=style&index=0&id=38415ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38415ad2",
  null
  
)

export default component.exports